import { Injectable } from '@angular/core';
//import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { CallLogModel, CallDetailLogModel } from '../models/calllog.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class CallLogService {
  //readonly BaseURI = GlobalConstants.apiURL;
  BaseURI : string;
  readonly apiController = "/CallLogs";
  form  = CallLogModel.getFormGroup();
  constructor(private http : HttpClient, private userservice : UserService) {
    console.log("constructor : CallLogService ");
    this.BaseURI = window.location.origin + "/api";
  }

  populateForm(item) {

    this.form.setValue(item);
   }


   getDetail(id)
   {
      return this.http.get(this.BaseURI + this.apiController + "/" + id);
   }

   getList()
   {
      return this.http.get(this.BaseURI + this.apiController);
   }

   getDetailList()
   {
      return this.http.get(this.BaseURI + this.apiController + "/CallDetailList");
   }

   insertData(item : CallLogModel) {
     item.createBy = this.userservice.getUserID();
     return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["callId", "status", "createTime", "endTime"]));
   }

   updateData(item : CallLogModel) {
     return this.http.put(this.BaseURI + this.apiController + "/" + item.callId, item);
   }


   deleteData(id)
   {
     return this.http.delete(this.BaseURI + this.apiController + "/" + id);

   }

   endCall(item : CallLogModel) {
    return this.http.put(this.BaseURI + this.apiController + "/EndCall?id=" + item.callId, item);
  }

   findDataByCustomer(id)
   {
     return this.http.get(this.BaseURI + this.apiController + "/FindByCustomer?id=" + id);
   }

   getRecentCallList(count)
   {

      return this.http.get(this.BaseURI + this.apiController + "/RecentCallLogDetailList?count=" + count);
   }

   getCallLogByWeek()
   {

      return this.http.get(this.BaseURI + this.apiController + "/CallLogByWeek");
   }

   getCallLogByMonth()
   {

      return this.http.get(this.BaseURI + this.apiController + "/CallLogByMonth");
   }

   initializeFormGroup(){
      CallLogModel.initializeFormGroup(this.form);
   }
}
